import React from 'react';
import { motion } from 'framer-motion';
import StarIcon from '@mui/icons-material/Star';
export function MoreTestimonials() {
  const testimonials = [{
    initials: 'CR',
    name: 'Cecilia R. (Mendoza)',
    tier: 'MegaPack + Kit Embajadora',
    quote: 'La planilla de cotización me salvó la vida. Cerré una mesa de fin de año para una bodega y recuperé la inversión del pack en el primer pedido. Mis clientas quedaron fascinadas con las velas que se comen.'
  }, {
    initials: 'SC',
    name: 'Sofía C. (La Plata)',
    tier: 'Emprendedora Gastronómica',
    quote: 'Mis velas de mantequilla especiada son el producto estrella de mis cajas de desayuno. Nadie hace esto en mi ciudad, me diferenció por completo de la competencia.'
  }];
  return <section className="py-12 px-6 bg-brand-cream" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        <div className="text-center mb-8" data-id="element-189">
          <h2 className="text-3xl font-serif font-bold text-brand-choco-deep" data-id="element-190">
            ❤️ MÁS CREATIVAS QUE YA LO TIENEN
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-191">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-brand-choco/5" data-id="element-192">
              <div className="flex items-center gap-4 mb-6" data-id="element-193">
                <div className="w-12 h-12 rounded-full bg-brand-gold text-brand-choco-deep flex items-center justify-center font-bold text-lg" data-id="element-194">
                  {t.initials}
                </div>
                <div data-id="element-195">
                  <div className="flex text-brand-gold mb-1" data-id="element-196">
                    {[...Array(5)].map((_, j) => <StarIcon key={j} fontSize="small" data-id="element-197" />)}
                  </div>
                  <p className="font-bold text-brand-choco-deep" data-id="element-198">{t.name}</p>
                  <p className="text-xs text-brand-choco/60 uppercase tracking-wide" data-id="element-199">
                    {t.tier}
                  </p>
                </div>
              </div>
              <p className="text-brand-choco-deep/80 italic leading-relaxed" data-id="element-200">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}